import React from 'react';
import {
  Route,
  NavLink 
} from 'react-router-dom';

class Dropdown extends React.Component {
	constructor(props) {
		super(props);
		this.state={
			open:false
		};
	}
	componentDidMount() {
        document.addEventListener('click', this.toggleOff.bind(this));
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.toggleOff.bind(this));
    }
	toggle(e) {
		e.nativeEvent.stopImmediatePropagation();
		console.log('toggle');
		//e.stopPropagation();
		e.preventDefault();
		e.stopPropagation();
		this.setState(prev => ({open:!prev.open}));
	}
	toggleOff() {
		this.setState({open:false});
	}
	render() {
		const open=!!this.state.open;
		console.log('open='+open);
		return (<li className={open ? 'nav-item dropdown show':'nav-item dropdown'}
			
		>
			<a className="nav-link dropdown-toggle" onClick={(e)=>this.toggle(e)} href="#openDropdown" id={this.props.id}>
				{this.props.title}
			</a>
			<div className={open ? 'dropdown-menu show':'dropdown-menu'} aria-labelledby={this.props.id} aria-expanded={open}>
			{this.props.children}
			</div>
		</li>);
	}
}

export class Nav extends React.Component {
	constructor(props) {
		super(props);
		this.state={
			open:false
		};
	}
	componentWillMount() {
		document.addEventListener('click',this.handleClick,false);
	}
	componentWillUnmount() {
		document.removeEventListener('click',this.handleClick,false);
	}
	handleClick = (e) => {
		console.log('handleClick');
		if (this.node.contains(e.target)) {
			console.log('//do nothing');
			return;
		}
		this.setState({open:false});
	}
	toggle(e) {
		console.log('toggle');
		e.stopPropagation();
		e.preventDefault();
		this.setState(prev => ({open:!prev.open}));
	}
	toggleOff = () => {
		this.setState({open:false});
	}
	render() {
		//const match=this.props.match;
		const open=!!this.state.open;
		return (
<Route>
	<nav className="navbar navbar-expand-md navbar-dark  bg-dark" ref={node => this.node=node}
		onClick={this.toggleOff}
		>
		<a className="navbar-brand" href="/">PACKETSMITER</a>
		<button className="navbar-toggler" type="button" data-toggle="collapse" 
			data-target="#navbarDefault" aria-controls="navbarDefault" 
			aria-expanded={open} aria-label="Toggle navigation"
			onClick={(e)=>this.toggle(e)}>
			<span className="navbar-toggler-icon"></span>
		</button>
		<div className={open ? 'collapse navbar-collapse show':'collapse navbar-collapse'} id="navbarDefault">
			<ul className="navbar-nav mr-auto">
				<li className="nav-item">
					<NavLink exact to="/" className="nav-link">Home</NavLink >
				</li>
				<Dropdown title="Projects" id="projectsDropdown">
					<a href="https://www.packetsmiter.com/EncryptedNotes/" className="dropdown-item">Encrypted Notes</a >
					<NavLink className="dropdown-item" to="/passgen/generatePass.pl">
						Passphrase Generator
					</NavLink>
					<a className="dropdown-item" href="https://www.packetsmiter.com/class_schedule/">Class scheduler for American River College, CRC, FLC, and SCC.</a>
				</Dropdown>
				<li className="nav-item">
					<NavLink  to="/about" className="nav-link" >About</NavLink >
				</li>
			</ul>
			<form className="form-inline my-2 my-lg-0" action="http://www.google.com/search">
				<input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" name="q" />
				<input type="hidden" value=" site:www.packetsmiter.com" name="q" />
				<button className="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
			</form>
		</div>
	</nav>
</Route>
);
	}
}


// WEBPACK FOOTER //
// ./src/Nav.js